import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '@/design-system/atoms/icon/icon.component';

@Component({
  selector: 'app-nav-item',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './nav-item.component.scss',
  templateUrl: './nav-item.component.html',
})
export class NavItemComponent {
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly active = input(false);
  readonly collapsed = input(false);
}
